<script setup>
import { ref, onMounted } from 'vue'
import {
  DxChart,
  DxSeries,
  DxLegend,
  DxTooltip,
  DxCommonSeriesSettings,
  DxLabel,
} from 'devextreme-vue/chart'
import { planningApi } from '@/apis/planning.api'

const DISPLAY_LABELS = {
  PLANNED:        'Planned',
  PRE_PRODUCTION: 'Pre-Production',
  PRODUCTION:     'Production',
  POST_PRODUCTION:'Post-Production',
  COMPLETED:      'Completed',
}

const DESCRIPTIONS = {
  PLANNED:        'Planned — production has not yet started',
  PRE_PRODUCTION: 'In pre-production phase',
  PRODUCTION:     'Currently in production',
  POST_PRODUCTION:'In post-production phase',
  COMPLETED:      'Production completed, not archived',
}

const data = ref(null)

onMounted(async () => {
  const res = await planningApi.getProjectPipelineSummaryAsync()
  data.value = res.data.map(({ status, count }) => ({
    category: DISPLAY_LABELS[status] ?? status,
    value: count,
    status,
  }))
})

const customizeTooltip = ({ argument, value, point }) => ({
  text: `${argument} (${value})\n${DESCRIPTIONS[point.data?.status] ?? argument}`,
})
</script>

<template>
  <div class="fit column" style="padding-left: 8px">
    <div v-if="data === null" class="col flex flex-center">
      <q-spinner size="md" color="primary" />
    </div>
    <dx-chart
      v-else
      :data-source="data"
      class="col"
      :bar-group-padding="0.5"
      :bar-group-width="40"
    >
      <dx-common-series-settings type="bar">
        <dx-label :visible="true" />
      </dx-common-series-settings>
      <dx-series argument-field="category" value-field="value" color="#1976D2" />
      <dx-legend :visible="false" />
      <dx-tooltip :enabled="true" :customize-tooltip="customizeTooltip" />
    </dx-chart>
  </div>
</template>
